"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollToTopButton = void 0;
var react_1 = __importDefault(require("react"));
var button_1 = require("@chakra-ui/button");
var icons_1 = require("@chakra-ui/icons");
var layout_1 = require("@chakra-ui/layout");
var react_2 = require("@emotion/react");
var react_3 = require("react");
exports.ScrollToTopButton = (0, react_3.memo)(function () {
    var onClickButton = function () {
        return window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };
    var getScrollTop = function () {
        return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    };
    var _a = (0, react_3.useState)(0), scrollTop = _a[0], setScrollTop = _a[1];
    var _b = (0, react_3.useState)(true), inView = _b[0], setInView = _b[1];
    var _c = (0, react_3.useState)(true), isHidden = _c[0], setIsHidden = _c[1];
    (0, react_3.useEffect)(function () {
        var onScroll = function () {
            setScrollTop(getScrollTop());
            setInView(scrollTop < 500);
            scrollTop > 500 && setIsHidden(false);
        };
        window.addEventListener("scroll", onScroll);
        return function () { return window.removeEventListener("scroll", onScroll); };
    }, [scrollTop]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(layout_1.Box, { position: "fixed", bottom: "7px", right: "7px", zIndex: "999" },
            react_1.default.createElement(button_1.IconButton, { background: "gray.200", display: "block", height: "28px", width: "28px", textAlign: "center", lineHeight: "28px", fontSize: "14px", color: "#000", opacity: "0.6", borderRadius: "2px", "aria-label": "up", icon: react_1.default.createElement(icons_1.ChevronUpIcon, null), css: [
                    isHidden && hidden,
                    fadeOutItem,
                    inView || fadeInItem,
                ], onClick: onClickButton }))));
});
var hidden = (0, react_2.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
var fadeIn = (0, react_2.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"], ["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
var fadeInItem = (0, react_2.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    animation: ", " 0.7s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;\n"], ["\n    animation: ", " 0.7s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;\n"])), fadeIn);
var fadeOut = (0, react_2.keyframes)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var fadeOutItem = (0, react_2.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    animation: ", " 0.7s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;\n"], ["\n    animation: ", " 0.7s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;\n"])), fadeOut);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
